import { Controller, useForm } from "react-hook-form";
import dayjs from '../../utils/dayjs-setup';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { GridLegacy as Grid, Dialog, DialogActions, DialogTitle, DialogContent, Button, Typography, Autocomplete, Input, TextField, CardContent, Card, InputLabel, IconButton, Chip, Alert, InputAdornment, Box, Tab, FormHelperText } from '@mui/material';
import { AxiosInstance, DateFormatString, DateTimeFormatString, DialogType, FormActions, FormatPrice, getLabelMunicipio, getRouteObject, getUrlImage, Perfiles } from "../../utils/constants";
import { AutoCompleteInputWithLabel, DateTimePickerInputWithLabel, InputFile, InputWithLabel, SelectInputWithLabel } from "./custom-imputs";
import { useContext, useEffect, useRef, useState } from "react";
import CloseIcon from '@mui/icons-material/Close';
import {  Delete, Save, WhatsApp } from "@mui/icons-material";
import { red } from "@mui/material/colors";
import { DatePicker, DateTimePicker } from "@mui/x-date-pickers";
import { ActionTypes, AppContext } from "../../store/AppStore";
import NotFile from "../../assets/images/no_file.png";
import styled from "@emotion/styled";
import { TabContext, TabList, TabPanel } from "@mui/lab";



const ImagenProduct = styled.img`
width:150px;
height:150px;
background-size:cover;
background-position:center;
border:solid #016B61 3px;
border-radius:10px;
`;

export const GenerarInputsForm = ({
    inputs, schemaValidation,
    entityValues,
    keyForm,
    onAddItem,
    onCancelCreation,
    okButtomText="Agregar",
    resetButtom={},
    onGetControlledValues=()=>{},
    sub_item_route_key
}) => {
    const { control, register, handleSubmit, formState: { errors },getValues,setValue,setError,clearErrors } = useForm({
        resolver: yupResolver(schemaValidation),
        defaultValues: entityValues
    });
    const formProps = {setValue,getValues,setError};
    const formRef = useRef(null);
    const [controlledValues,setControlledValues] = useState({});

    useEffect(()=>{
        onGetControlledValues(controlledValues);
    },[controlledValues]);

    const validateObject =  async ()=>{
        let errors = [];
        var formData = new FormData(formRef.current);
        
        let objectForm = {};
        for( let pair of formData.entries() ){
           objectForm[pair[0]] = pair[1];
        }
        objectForm = {...entityValues,...objectForm,...controlledValues};

        try{
         const errorsSchema = await  schemaValidation.validate(objectForm,{abortEarly:false});
        }catch(e){
         
            errors = e.inner?.map(innerError=>({
             type:innerError.type,
             name:innerError.path,
             message:innerError.message
            }));
    
        }
        return {
            validationErrors:errors,
            objectForm
        };
    }

    const onSubmitForm = async(evt)=>{
     
     
       
        let {validationErrors,objectForm} = await validateObject();
       
        clearErrors();
       if ( validationErrors?.length > 0  ){
        for(const errorItem of validationErrors ){
            setError(errorItem.name,errorItem);
        }
        return ;
       }
       objectForm.key =  sub_item_route_key? getRouteObject(objectForm,sub_item_route_key):Object.values(objectForm).join("-");
       
       onAddItem(objectForm);
       formRef.current.reset();
       setControlledValues({});


       
        
      
        return false;
    }

    const onChangeControlledValue = (value,name,inputType)=>{
       
        if(inputType === 'date'){
            setValue("fecha_entrega",dayjs(value));
            setControlledValues({...controlledValues,[name]:dayjs(value)});
           
        }else{
            setControlledValues({...controlledValues,[name]:value});
        }
       
      
    }

    return (
        <form ref={formRef} style={{width:'100%'}}  >
        <Grid container spacing={1} >

       {
            inputs.filter(item => !item.generateDinamyc).map(inputItem =>
                {
                
                return  <Grid item sm={inputItem.responsiveSize || 6} md={inputItem.responsiveSize || 6} key={inputItem.key} >
                    <Controller
                        control={control}
                        name={inputItem.keyValue}
                        render={({ field }) => <inputItem.component
                            keyValue={inputItem.keyValue}
                            errorMessage={errors[inputItem.keyValue]?.message}
                            label={inputItem.label}
                            {...inputItem.inputProps}
                            {...field}
                            onChange={ value=>{

                                if (inputItem.callFuncionOnChange){
                                    inputItem.callFuncionOnChange(value,formProps);
                                }
                                ["autoComplete","date"].includes( inputItem.inputProps.typeInput )?onChangeControlledValue(value,inputItem.keyValue,inputItem.inputProps.typeInput)
                                :field.onChange(value);
                            }
                             }
                             
                        />}
                    />

                </Grid>}
            )
        }
       <Grid item md={12}   >
       
       <Button size="small" type="button" sx={{marginRight:2}} onClick={onCancelCreation} color="secondary"  variant="contained" >Cancelar</Button>
       <Button size="small" type="button" onClick={onSubmitForm}  variant="contained" >{okButtomText}</Button>
       {Object.keys(resetButtom).length > 0 && <Button   size="small" color="error" type="button" onClick={()=>resetButtom.action(entityValues)}  variant="contained" >{resetButtom.text}</Button>}
      

       </Grid>
      

    </Grid>
    </form>
    )
}


export const ModalFormMultiple = ({dialog_title='',arrayOfForms = [],onOpen,onClose,is_visible})=>{

    const [value, setValue] = useState(arrayOfForms.length > 0?arrayOfForms[0].titleModal:null);

    const handleChange = (event, newValue) => {
      setValue(newValue);
    };
  

    const newArrayOfForms = arrayOfForms.map( forms =>{
        return {
            ...forms,
            buttomsAction:[
                {
                    title:"Cancelar",
                    buttomProps:{
                      size:"small",
                      type:"button",
                      onClick:()=>{
                        onClose();
                     },
                      color:"secondary"
                  }
                }

            ].concat(forms.buttomsAction)
        }
    } );
    return (
        <Dialog
        open={is_visible}
        maxWidth={"sm"}
    >
        <DialogTitle  sx={{ m: 0, p: 2 }} >
            {dialog_title}
        </DialogTitle>
      
      
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
            <DialogContent>
                <Box sx={{ width: '100%', typography: 'body1' }}>
                    <TabContext value={value}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <TabList onChange={handleChange} aria-label="GROUP OF FORMS">
                            {
                                newArrayOfForms.map(formItem=><Tab key={formItem.titleModal} label={formItem.titleModal} value={formItem.titleModal} />)
                            }
                        
                        </TabList>
                        </Box>
                            {
                                newArrayOfForms.map(formItem=><TabPanel key={formItem.titleModal} value={formItem.titleModal}><ModalFormGeneradorMultiple {...formItem} /></TabPanel>)
                            }
                    
                        
                    </TabContext>
                </Box>
            </DialogContent>
        </Dialog>
     
      );
}

export const ModalFormGenerador = ({
    isVisible = false,
    schemaValidator = null,
    titleModal = '',
    buttomsAction = [],
    entityValues = {},
    imputs = [],
    arrayInputs:new_array = [],
    onSendForm = () => { },
    typeAction = FormActions.AGREGAR,
    maxWidth= "sm",
    FooterElement=null
}) => {
    const { control, register,watch, handleSubmit ,formState: { errors },...propsForm } = useForm({
        resolver: yupResolver(schemaValidator),
        defaultValues: entityValues
    });
    const [arrayInputs,setArrayInputs] = useState([]);

   useEffect(()=>{
    let cloneOrigin = [...new_array];
    arrayInputs.forEach((item,index)=>{
        cloneOrigin[index].opened = item.opened;
    });
    setArrayInputs(cloneOrigin);
   },[new_array]);

    const onSubmit = data => {
        onSendForm(typeAction, data,propsForm);
    }

    const subItemCreationCallBack = (field,value,callBack,subItemIndex) => {
        const newArrayInputs = [...arrayInputs];
        const items = [...(field.value || [])].concat([value]);
        newArrayInputs[subItemIndex].opened = false;
        setArrayInputs(newArrayInputs);
        console.log({
            total:items,
            newValue:field.value,
            actual_value:value
        });
        field.onChange(items);
        callBack(items,propsForm);
    }
    const subItemDeletetionCallBack = (field,indexItem,callBack,subItemIndex) => {
       
        const newArrayInputs = [...arrayInputs];
        newArrayInputs[subItemIndex].opened = false;
        setArrayInputs(newArrayInputs);
        let arrayDirs = field.value.filter((ele,index)=>index !==indexItem);
        field.onChange(arrayDirs);
        callBack(arrayDirs,propsForm);
    }
    const cancelSubItemCreation = (subItemIndex)=>{
        const newArrayInputs = [...arrayInputs];
        newArrayInputs[subItemIndex].opened = false;
        setArrayInputs(newArrayInputs);
    }


    const subItems = imputs.filter(item => item.generateDinamyc);


    const openOrCloseSubItem = (sub_item_index)=>{
        const newArrayInputs = [...arrayInputs];
        newArrayInputs[sub_item_index].opened = true;
        setArrayInputs(newArrayInputs);
    }

    return (<Dialog
        open={isVisible}
        maxWidth={maxWidth}
    >
        <DialogTitle>
            {titleModal}
        </DialogTitle>
        <DialogContent>
            <form
                onSubmit={handleSubmit(onSubmit)}
            >
                <Grid container spacing={1} >

                    {
                        imputs.filter(item => !item.generateDinamyc).map(inputItem =>
                            <Grid item sm={inputItem.responsiveSize || 6} md={inputItem.responsiveSize || 6} key={inputItem.key} >
                                <Controller
                                    control={control}
                                    name={inputItem.keyValue}
                                    render={({ field }) => <inputItem.component
                                        keyValue={inputItem.keyValue}
                                        errorMessage={errors[inputItem.keyValue]?.message}
                                        label={inputItem.label}
                                        {...inputItem.inputProps}

                                        {...field}
                                        onChange={(props)=>{
                                            const value = props?.target?.value || props;
                                            if ( !value){
                                                console.error("ERROR NO CONTROLADO EN MODAL FORM");
                                            }
                                            field.onChange(value);
                                            if (inputItem.callFuncionOnChange){
                                                inputItem.callFuncionOnChange(value,propsForm);
                                            }
                                            
                                        }}
                                 
                                    />}
                                   
                                />
                                
                            </Grid>
                        )
                    }

                    {
                        arrayInputs.length > 0 &&
                        arrayInputs.map((subItem,subItemIndex) =>
                            {
                            const {ItemRender} =  subItem;
                           
                              return  <Grid key={subItem.key} item sm={12} md={12}  >
                                <Controller
                                    key={subItem.key}
                                    control={control}
                                    name={subItem.keyValue}
                                    render={({ field }) =>
                                        <Grid container spacing={1} >
                                            <Grid item sm={12} md={8} >
                                                <Typography variant="h6" >{subItem.label}</Typography>
                                            </Grid>
                                            <Grid   item sm={12} md={4} >
                                                <Button disabled={ subItem.itemRenderProps?.add === false}  onClick={e=>openOrCloseSubItem(subItemIndex)} type="button" variant="contained" >Nuevo</Button>
                                            </Grid>
                                               {subItem.opened && <Grid item sm={12} sx={12} md={12} >
                                               <GenerarInputsForm
                                               keyForm={subItem.key}
                                            inputs={subItem.inputs}
                                            schemaValidation={subItem.subSchema}
                                            entityValues={{}}
                                            onAddItem={ value =>subItemCreationCallBack(field,value,subItem.callFuncionOnChange?subItem.callFuncionOnChange:()=>{},subItemIndex  )}
                                            onCancelCreation={()=>cancelSubItemCreation(subItemIndex)}
                                            
                                            />
                                                </Grid>}
                                              
                                               { field.value?.map((dir_item,indexItemRender)=>{
                                                
                                                return <ItemRender 
                                                itemRenderProps={ {...(subItem.itemRenderProps || {})} }
                                                
                                                onDeleteIcon={e=>subItemDeletetionCallBack(field,indexItemRender,subItem.callFuncionOnChange?subItem.callFuncionOnChange:()=>{},subItemIndex )}  
                                                key={dir_item.cod || dir_item.key} {...dir_item} />
                                               })} 
                                               
                                           
                                        </Grid>
                                    }
                                />



                            </Grid>
                            }




                        )



                    }

                    {
                        subItems.length > 0 ? <>
                            {
                                subItems.map(subItem => <Grid key={subItem.label} item sm={12} md={12}  >
                                    <Grid container spacing={1} >
                                        <Grid item sm={12} md={12} >
                                            <Typography variant="h6" >{subItem.label}</Typography>
                                        </Grid>
                                        {subItem.ArrayList.map(subInput => <Grid key={subInput[subItem.ArrayInputsProps.key]} item sm={6} md={6}  >

                                            <Controller
                                                control={control}
                                                name={subInput[subItem.ArrayInputsProps.keyValue]}
                                                render={({ field }) => <subItem.component
                                                    type={subItem.ArrayInputsProps.type}
                                                    keyValue={subItem.ArrayInputsProps.keyValue}
                                                    errorMessage={""}
                                                    label={subInput[subItem.ArrayInputsProps.keyValue]}

                                                    {...field}
                                                    onChange={(props)=>{
                                                        console.log("mis props");
                                                        const value = props?.target?.value || props;
                                                        if ( !value){
                                                            console.error("ERROR NO CONTROLADO EN MODAL FORM");
                                                        }
                                                        field.onChange(value);
                                                        console.log("change",value);
                                                        if (subItem.ArrayInputsProps.callFuncionOnChange){
                                                            subItem.ArrayInputsProps.callFuncionOnChange(value);
                                                        }
                                                        
                                                    }}
                                                />}
                                            />

                                        </Grid>)}
                                    </Grid>
                                    <Grid>

                                    </Grid>
                                </Grid>)
                            }
                        </> : <></>
                    }


                    <Grid item sm={12} md={12} >
                        { FooterElement && <FooterElement /> }
                    </Grid>


                    <Grid item sm={12} md={12} >
                        <DialogActions>
                          
                            {buttomsAction.map(buttom =>{ 
                            
                            return<Button
                                {...buttom.buttomProps}
                                
                                variant='contained'
                            >
                                {buttom.title}
                            </Button>})}
                        </DialogActions>
                    </Grid>
                  
                </Grid>
            </form>
        </DialogContent>

    </Dialog>)

}

export const ModalFormGeneradorMultiple = ({
    schemaValidator = null,
    buttomsAction = [],
    entityValues = {},
    imputs = [],
    arrayInputs:new_array = [],
    onSendForm = () => { },
    typeAction = FormActions.AGREGAR,
    FooterElement=null
}) => {
    const { control, register, handleSubmit ,formState: { errors },...formProps } = useForm({
        resolver: yupResolver(schemaValidator),
        defaultValues: entityValues
    });
    const [arrayInputs,setArrayInputs] = useState([]);
    const {dispatch} = useContext( AppContext );
   useEffect(()=>{
    let cloneOrigin = [...new_array];
    arrayInputs.forEach((item,index)=>{
        cloneOrigin[index].opened = item.opened;
    });
    setArrayInputs(cloneOrigin);
   },[new_array]);

    const onSubmit = data => {
        onSendForm(typeAction, data,formProps);
    }

    const subItemCreationCallBack = (field,value,callBack,subItemIndex) => {
        console.log({value});
        const newArrayInputs = [...arrayInputs];
        const existItem = field.value?.some(item=>item.key === value.key);
       
        if ( existItem ){
            dispatch({
                type:ActionTypes.setModalInfo,
                data:{
                    title:"Item repetido",
                    message:"El item ya ha sido agregado",
                    type:DialogType.peligro,
                    isVisible:true
                }
            });
            return;
        }
        const items = [value].concat( [...(field.value || [])] );
        newArrayInputs[subItemIndex].opened = false;
        setArrayInputs(newArrayInputs);
        field.onChange(items);
        callBack(items,formProps);
    }
    const subItemDeletetionCallBack = (field,item,callBack,subItemIndex) => {
        const newArrayInputs = [...arrayInputs];
        newArrayInputs[subItemIndex].opened = false;
        
        let arrayDirs = field.value.filter((ele,index)=>item.key !==ele.key);
        console.log({arrayDirs,field,subItemIndex});
        field.onChange(arrayDirs);
        setArrayInputs(newArrayInputs);
        callBack(arrayDirs,formProps);
    }
    const cancelSubItemCreation = (subItemIndex)=>{
        const newArrayInputs = [...arrayInputs];
        newArrayInputs[subItemIndex].opened = false;
        setArrayInputs(newArrayInputs);
    }


    const subItems = imputs.filter(item => item.generateDinamyc);


    const openOrCloseSubItem = (sub_item_index)=>{
        const newArrayInputs = [...arrayInputs];
        newArrayInputs[sub_item_index].opened = true;
        setArrayInputs(newArrayInputs);
    }
    console.log({errors});
    return (
        <form
        onSubmit={handleSubmit(onSubmit)}
    >
        <Grid container spacing={1} >

            {
                imputs.filter(item => !item.generateDinamyc).map(inputItem =>
                   {
                   return <Grid item sm={inputItem.responsiveSize || 6} md={inputItem.responsiveSize || 6} key={inputItem.key} >
                    <Controller
                        control={control}
                        name={inputItem.keyValue}
                        render={({ field }) => <inputItem.component
                            keyValue={inputItem.keyValue}
                            errorMessage={errors[inputItem.keyValue]?.message}
                            label={inputItem.label}
                            {...inputItem.inputProps}

                            {...field}
                            onChange={(props)=>{
                                const value = props?.target?.value || props;
                                if ( !value){
                                    console.error("ERROR NO CONTROLADO EN MODAL FORM");
                                }
                                field.onChange(value);
                                if (inputItem.callFuncionOnChange){
                                    inputItem.callFuncionOnChange(value,formProps);
                                }
                                
                            }}
                     
                        />}
                       
                    />
                    
                </Grid>
                   }
                )
            }

            {
                arrayInputs.length > 0 &&
                arrayInputs.map((subItem,subItemIndex) =>
                    {
                    const {ItemRender,CustomModal = null,customModalProps={}} =  subItem;
                   
                      return  <Grid key={subItem.key} item sm={12} md={12}  >
                        <Controller
                            key={subItem.key}
                            control={control}
                            name={subItem.keyValue}
                            render={({ field }) =>
                                <Grid container spacing={1} >
                                    <Grid item sm={12} md={8} >
                                        <Typography variant="h6" >{subItem.label}</Typography>
                                    </Grid>
                                    <Grid   item sm={12} md={4} >
                                        <Button disabled={ subItem.itemRenderProps?.add === false}  onClick={e=>openOrCloseSubItem(subItemIndex)} type="button" variant="contained" >Nuevo</Button>
                                    </Grid>
                                    {
                                        subItem.type_vew === 'modal'?
                                        <CustomModal is_opened={subItem.opened} 
                                        listResult={customModalProps.options}
                                        onClose={()=>cancelSubItemCreation(subItemIndex)}
                                        onSearchProduct={customModalProps.onInputChange} 
                                        configClient={customModalProps.configCliente}
                                        onAddItem={ value =>subItemCreationCallBack(field,value,subItem.callFuncionOnChange?subItem.callFuncionOnChange:()=>{},subItemIndex  )}
                                        />
                                        :null
                                    }
                                   
                                       <Grid item sm={12} sx={12} md={12} >
                                       {subItem.opened && subItem.type_vew !== 'modal' && 
                                    <GenerarInputsForm
                                        keyForm={`${subItem.key}-item-creacion`}
                                        sub_item_route_key={subItem.key_item}
                                      inputs={subItem.inputs}
                                      schemaValidation={subItem.subSchema}
                                      entityValues={{}}
                                      onAddItem={ value =>subItemCreationCallBack(field,value,subItem.callFuncionOnChange?subItem.callFuncionOnChange:()=>{},subItemIndex  )}
                                      onCancelCreation={()=>cancelSubItemCreation(subItemIndex)}
                                      
                                      />
                                       }
                                     
                                        </Grid>
                                       
                                       { [...field?.value || []].map((dir_item,indexItemRender)=>{
                                     
                                        return <ItemRender 
                                        item_index={indexItemRender}
                                        fieldForm={field}
                                        callFuncionOnChange={subItem.callFuncionOnChange?subItem.callFuncionOnChange:()=>{}}
                                        itemRenderProps={ {...(subItem.itemRenderProps || {})} }
                                        
                                        onDeleteIcon={e=>subItemDeletetionCallBack(field,dir_item,subItem.callFuncionOnChange?subItem.callFuncionOnChange:()=>{},subItemIndex )}  
                                        key={  dir_item.key ||  dir_item.cod } {...dir_item} />
                                       })} 
                                       
                                   
                                </Grid>
                            }
                        />



                    </Grid>
                    }




                )



            }

            {
                subItems.length > 0 ? <>
                    {
                        subItems.map(subItem => <Grid key={subItem.label} item sm={12} md={12}  >
                            <Grid container spacing={1} >
                                <Grid item sm={12} md={12} >
                                    <Typography variant="h6" >{subItem.label}</Typography>
                                </Grid>
                                {subItem.ArrayList.map(subInput => <Grid key={subInput[subItem.ArrayInputsProps.key]} item sm={6} md={6}  >

                                    <Controller
                                        control={control}
                                        name={subInput[subItem.ArrayInputsProps.keyValue]}
                                        render={({ field }) => <subItem.component
                                            type={subItem.ArrayInputsProps.type}
                                            keyValue={subItem.ArrayInputsProps.keyValue}
                                            errorMessage={""}
                                            label={subInput[subItem.ArrayInputsProps.keyValue]}

                                            {...field}
                                            onChange={(props)=>{
                                                console.log("mis props");
                                                const value = props?.target?.value || props;
                                                if ( !value){
                                                    console.error("ERROR NO CONTROLADO EN MODAL FORM");
                                                }
                                                field.onChange(value);
                                                console.log("change",value);
                                                if (subItem.ArrayInputsProps.callFuncionOnChange){
                                                    subItem.ArrayInputsProps.callFuncionOnChange(value,formProps);
                                                }
                                                
                                            }}
                                        />}
                                    />

                                </Grid>)}
                            </Grid>
                            <Grid>

                            </Grid>
                        </Grid>)
                    }
                </> : <></>
            }


            <Grid item sm={12} md={12} >
                { FooterElement && <FooterElement /> }
            </Grid>


            <Grid item sm={12} md={12} >
                <DialogActions>
                  
                    {buttomsAction.map(buttom =>{ 
                    
                    return<Button
                        {...buttom.buttomProps}
                        
                        variant='contained'
                    >
                        {buttom.title}
                    </Button>})}
                </DialogActions>
            </Grid>
          
        </Grid>
    </form>
    )

}


const schemaOferta = yup.object({
    producto: yup.object().shape({
        label: yup.string(),
        value: yup.number()
    }).test("is_selected", (value, ctx) => {

        if (!value.value) {
            return ctx.createError({ message: 'Debe seleccionar un producto' })
        }
        return true;
    }
    ),
    
    cantidad_minima_oferta:yup.string().optional().notRequired().nullable(),
    cantidad_maxima_oferta:yup.string().optional().notRequired().nullable(),
    cod_unidad_medida: yup.number().required(),
    audiencType: yup.string().required(),
    cod_clasificacion_cliente: yup.array().nullable().test("has_clasificacion_cliente", (value, ctx) => {

        if (ctx.parent.audiencType === 'TIPOS_CLIENTES' && value.length === 0) {
            return ctx.createError({ message: 'Seleccione un tipo de cliente' })
        }
        

        return true;
    }),
    subtipo_cliente: yup.object().nullable().test("has_subtipo", (value, ctx) => {

        if (ctx.parent.audiencType === 'CLASIFICACION_CLIENTE' && !value) {
            return ctx.createError({ message: 'Seleccione el subtipo' })
        }
        

        return true;
    }),
    tamanio_cliente: yup.object().nullable().test("has_tamanio", (value, ctx) => {

        if (ctx.parent.audiencType === 'CLASIFICACION_CLIENTE' && !value) {
            return ctx.createError({ message: 'Seleccione el tamaño' })
        }
        

        return true;
    }

    ).notRequired(),
    cliente_especifico: yup.array().of(yup.object({
        label: yup.string(),
        value: yup.number()
    })).test("is_selected", (value, ctx) => {
        if (ctx.parent.audiencType === 'CLIENTES' && value.length === 0  ) {
            return ctx.createError({ message: 'Seleccione un cliente' })
        }

        return true;
    }

    ).nullable(true).notRequired(),
    fecha_desde: yup.string().required(),
    fecha_disponibilidad:yup.string().required().test("is_before_fecha_desde_dis",(value,ctx)=>{
        if ( dayjs(value).isBefore(dayjs(ctx.parent.fecha_desde)) ){
            return ctx.createError({ message: 'La fecha debe ser mayor a la fecha inicial' });
        }
        return true;
    }),
    fecha_hasta: yup.string().nullable().notRequired().test("is_before_fecha_desde",(value,ctx)=>{
        if ( value){
            if ( dayjs(ctx.parent.fecha_desde).isAfter( dayjs(value) ) ){
                return ctx.createError({ message: 'La fecha debe ser mayor a la fecha final' });
            }else if ( dayjs(ctx.parent.fecha_desde).isSame( dayjs(value) )){
                return ctx.createError({ message: 'La fecha debe ser diferente a la inicial' });
            }
        }

        return true;
    }),
    es_especial:yup.string().required(),
    centros_operacion:yup.array().of(yup.object({
        centro_operacion_cod:yup.string().required(),
        costo_promedio:yup.number().required(),
        cantidad_disponible:yup.number().required(),
        margen_venta:yup.number().min(0).max(100).required()
    })).required("Debe agregar la cobertura de la oferta")

}).required();
export const ModalFormOferta = ({
    isVisible = false,
    titleModal = '',
    buttomsAction = [],
    entityValues,
    initialData = {},
    onSendForm = () => { },
    typeAction = FormActions.AGREGAR
}) => {
    const { control, set, register, watch, handleSubmit, setValue,getValues, formState: { errors, }, setError } = useForm({
        resolver: yupResolver(schemaOferta),
        defaultValues: entityValues
    });
    const {dispatch,store:{profile}} = useContext( AppContext );
    const configuracionApp = profile.configuracion_comp? JSON.parse(profile.configuracion_comp):{};
    const [productosOptions, setProductosOptions] = useState([]);
    const [unidadesMedidas, setUnidadesMedidas] = useState([]);

    const [listClientes, setListClientes] = useState([]);
    const [subtipoList, setSubtipoList] = useState([]);
    const [tamanioList, setTamanioList] = useState([]);


    const tipoAudienciaSeleccionada = watch("audiencType");
    const productoSeleccionado = watch("producto");
    const fecha_desde_select = watch("fecha_desde");
    const hassDisabledInputs = entityValues.sync_automatica === 'SI' || entityValues.count_pedidos > 0;
    const hasDisabledOptions  =  ![Perfiles.administrador,Perfiles["administrador-punto-venta"]].includes(profile?.perfil?.cod); 

    const tipoAudicencia = [{
        label: "Todos los clientes",
        value: 'TODOS',
        desc: "clientes que actualmente comprar en producto"
    },
    {
        label: "Tipo de clientes",
        value: "TIPOS_CLIENTES",
        desc: "todos los clientes que sean de este tipo"
    },
    {
        label: "Clasificacion de cliente",
        value: "CLASIFICACION_CLIENTE",
        desc: "Clientes por tipo y tamaño"
    },
    {
        label: "Clientes especificos",
        value: "CLIENTES",
        desc: "cliente especifico"
    }
    ];


    useEffect(() => {

        getTipoOrSubtipo(configuracionApp.REG_CLIENTE.clasificacion_planes.c2,'subtipo');
        getTipoOrSubtipo(configuracionApp.REG_CLIENTE.clasificacion_planes.c3,'tamanio');
    }, []);

    useEffect(() => {

        if (productoSeleccionado && productoSeleccionado.value) {
            getUnidadesMedidasProd(productoSeleccionado?.value);
            setValue("product_image", productoSeleccionado?.producto_imagen?.url_imagen);
        }




    }, [productoSeleccionado]);
    const getUnidadesMedidasProd = async (cod_prod) => {
        let ListUnidadesResult = await AxiosInstance.get("maestros-marketplace/get-unidades-medidas-prod/" + cod_prod);
        setUnidadesMedidas(ListUnidadesResult.data.value);
    }

    const getTipoOrSubtipo = async (cod_erp_plan,typeQuery) => {

        if ( cod_erp_plan){
            let {data:{value}} = await AxiosInstance.post("maestros-marketplace/get-tipos-subtipos/", {
                cod_erp_plan
            });
           typeQuery === 'subtipo'?setSubtipoList(value):setTamanioList(value);
        }


    }



    const getClientsFilter = async (text) => {
        let clients = [];

        try {
            let ListClientResult = await AxiosInstance.post(`maestros-marketplace/get-clientes-enabled-filtro/${profile.cod_cia || ''}`, {
                text_search: text
            });
            clients = ListClientResult.data.value;
        } catch (e) {

        }

        return clients;


    }

    const onSubmit = data => {
        
        onSendForm(typeAction, data);
    }

    const onSearchProducto = async (value_search) => {

        if (value_search) {
            try {

                const { data: { value } } = await AxiosInstance.post(`maestros-marketplace/filtrar-portafolio-venta/${profile.cod_cia || ''}`, {
                    search_query: value_search
                });
                return value;
            } catch (e) {
                return [];
            }

        }



    }
    const searcProductoAsociado = async (event, newInputValue) => {
        console.log({event,newInputValue});
        try {
            let res = await onSearchProducto(newInputValue);
            setProductosOptions(res);
           
        } catch (e) {
            console.log(e.message);
        } 
    }

    const searchClient = async (event, newInputValue) => {

        if ( newInputValue && newInputValue?.length > 3 &&  newInputValue?.length %2 === 0 ){
            try {
                let res = await getClientsFilter(newInputValue);
                setListClientes(res);
            } catch (e) {
    
            }
        }
        
    }

    const onAddCobertura = ()=>{
    const list = getValues("centros_operacion") || [];
    const consecutivo = list?.length > 0? list?.[list.length-1].cod + 1  :1;
    console.log({consecutivo});
    const obectToInsert =  {
        cod:consecutivo,
        agregado:true,
        centro_operacion_cod:null,
        costo_promedio:0,
        margen_venta:0
    };
    setValue("centros_operacion",list?.length ===  0? [
        obectToInsert
    ]: list.concat([obectToInsert]));
    }
    const onRemoveItemFormParent = (key_field,cod_item)=>{
        const list = getValues("centros_operacion") || [];
        setValue("centros_operacion", list.filter(item=>item.cod !== cod_item) );
    }

    const onChangeChildValue = (keyParent,parentIndex,child_key,child_value)=>{
      let list = getValues(keyParent);
      list[parentIndex][child_key] = child_value;
      setValue(keyParent,list);
    }


    console.log({ errors });

    return (<Dialog
        open={isVisible}
    >
        <DialogTitle>
            {titleModal}
        </DialogTitle>
        <DialogContent>
            <form
                onSubmit={handleSubmit(onSubmit)}
            >
                <Grid container spacing={1} >

                <Grid item sm={12} md={8} >
                        <Controller
                            control={control}
                            name={"producto"}
                            render={({ field }) => <AutoCompleteInputWithLabel

                                keyValue={field.name}
                                errorMessage={errors[field.name]?.message}
                                label={"Producto a lanzar"}
                                {... {
                                    name: 'producto',
                                    fullWidth: true,
                                    isLoading: false,
                                    multiple: false,
                                    disabled:hassDisabledInputs || hasDisabledOptions,
                                    PopperComponent: (props) => <div hidden={!props.open} >

                                        {props.children}
                                    </div>,
                                    onInputChange: searcProductoAsociado,
                                    options: productosOptions || [],
                                    noOptionsText: "Lista vacia",
                                    getOptionLabel: (option) => option.label,
                                    isOptionEqualToValue: (option, value) => option.value === value.value,
                                    filterOptions: (x) => x,
                                    size: "small"
                                }}
                                {...field}

                            />}
                        />
                    </Grid>
                    <Grid item sm={4} md={4} >
                        <ImagenProduct src={productoSeleccionado?.url_imagen ? getUrlImage(productoSeleccionado?.url_imagen) : NotFile} />
                    </Grid>


                    <Grid item sm={4} md={4} >

                        <Controller
                            control={control}
                            name={"cod_unidad_medida"}
                            render={({ field }) => <SelectInputWithLabel
                                keyValue={field.name}
                                errorMessage={errors[field.name]?.message}
                                label={"U.M venta"}
                                items={unidadesMedidas}
                                disabled={hassDisabledInputs ||  hasDisabledOptions}
                                {...field}
                                size="small"
                            />}
                        />

                    </Grid>
                    <Grid item sm={4} md={4} >

                        <Controller
                            control={control}
                            name={"cantidad_minima_oferta"}
                            render={({ field }) => <InputWithLabel
                                keyValue={field.name}
                                errorMessage={errors[field.name]?.message}
                                label={"Cant. Min a vender"}
                                disabled={hassDisabledInputs ||  hasDisabledOptions}
                                {...field}
                            />}
                        />

                    </Grid>

                    <Grid item sm={4} md={4} >

                        <Controller
                            control={control}
                            name={"cantidad_maxima_oferta"}
                            render={({ field }) => <InputWithLabel
                                keyValue={field.name}
                                errorMessage={errors[field.name]?.message}
                                label={"Cant. Max a vender"}
                                {...field}
                                disabled={hassDisabledInputs ||  hasDisabledOptions}
                            />}
                        />

                    </Grid>

                    <Grid item sm={12} md={12} >

                        <Controller
                            control={control}
                            name={"audiencType"}
                            render={({ field }) => <SelectInputWithLabel
                                keyValue={field.name}
                                errorMessage={errors[field.name]?.message}
                                label={"Publico al que va dirigido"}
                                items={tipoAudicencia}
                                disabled={hassDisabledInputs ||  hasDisabledOptions}
                                {...field}
                                size="small"
                            />}
                        />

                    </Grid>

                    {
                        tipoAudienciaSeleccionada === 'TIPOS_CLIENTES' &&
                        <Grid item sm={6} md={6} >

                            <Controller
                                control={control}
                                name={"cod_clasificacion_cliente"}
                                render={({ field }) => <AutoCompleteInputWithLabel
                                    multiple={true}
                                    keyValue={field.name}
                                    errorMessage={errors[field.name]?.message}
                                    label={"Tipos de clientes"}
                                   
                                    {...field}
                                    size="small"
                                    {... {
                                        name: field.name,
                                        fullWidth: true,
                                        isLoading: false,
                                        multiple: true,
                                        disabled:hassDisabledInputs || hasDisabledOptions,
                                        PopperComponent: (props) => <div hidden={!props.open} >

                                            {props.children}
                                        </div>,
                                        //onInputChange: searchClient,
                                        options: initialData.clasificacionClientes || [],
                                        noOptionsText: "Lista vacia",
                                        getOptionLabel: (option) => option.label,
                                        isOptionEqualToValue: (option, value) => option.value === value.value,
                                        filterOptions: (x) => x,
                                        size: "small"
                                    }}
                                />}
                            />
                        </Grid>
                    }
                        {
                        tipoAudienciaSeleccionada === 'CLASIFICACION_CLIENTE' &&
                        <Grid container item sm={12} md={12} >

                            <Grid item sm={6} md={6} >
                                <Controller
                                    control={control}
                                    name={"subtipo_cliente"}
                                    render={({ field }) => <AutoCompleteInputWithLabel
                                    multiple={true}
                                    keyValue={field.name}
                                    errorMessage={errors[field.name]?.message}
                                    label={"Subtipo de cliente"}
                                    disabled={hassDisabledInputs || hasDisabledOptions}
                                    {...field}
                                    size="small"
                                        {... {
                                            name: field.name,
                                            fullWidth: true,
                                            isLoading: false,
                                            multiple: false,
                                            disablePortal:true,
                                            PopperComponent: (props) => <div hidden={!props.open} >

                                                {props.children}
                                            </div>,
                                            options: subtipoList || [],
                                            
                                            size: "small"
                                        }}



                                    />}
                                />
                            </Grid>
                            <Grid item sm={6} md={6} >
                                <Controller
                                    control={control}
                                    name={"tamanio_cliente"}
                                    render={({ field }) => <AutoCompleteInputWithLabel
                                    multiple={true}
                                    keyValue={field.name}
                                    errorMessage={errors[field.name]?.message}
                                    label={"Tamaño de cliente"}
                                    disabled={hassDisabledInputs || hasDisabledOptions}
                                    {...field}
                                    size="small"
                                        {... {
                                            name: field.name,
                                            fullWidth: true,
                                            isLoading: false,
                                            multiple: false,
                                            disablePortal:true,
                                            PopperComponent: (props) => <div hidden={!props.open} >

                                                {props.children}
                                            </div>,
                                            options: tamanioList || [],
                                            size: "small"
                                        }}



                                    />}
                                />
                            </Grid>
                        </Grid>
                    }
                   
                   {
                        tipoAudienciaSeleccionada === 'CLIENTES' &&
                        <Grid item sm={6} md={6} >

                            <Controller
                                control={control}
                                name={"cliente_especifico"}
                                render={({ field }) => <AutoCompleteInputWithLabel
                                multiple={true}
                                keyValue={field.name}
                                errorMessage={errors[field.name]?.message}
                                label={"Clientes"}
                               
                                {...field}
                                size="small"
                                    {... {
                                        name: field.name,
                                        fullWidth: true,
                                        isLoading: false,
                                        multiple: true,
                                        PopperComponent: (props) => <div hidden={!props.open} >

                                            {props.children}
                                        </div>,
                                        onInputChange: searchClient,
                                        options: listClientes || [],
                                        noOptionsText: "Lista vacia",
                                        getOptionLabel: (option) => option.label,
                                        isOptionEqualToValue: (option, value) => option.value === value.value,
                                        filterOptions: (x) => x,
                                        size: "small"
                                    }}



                                />}
                            />
                        </Grid>
                    }



                   
                    <Grid item sm={12} md={12} >
                        <Typography variant="h6" >Vigencia de la oferta</Typography>

                    </Grid>
                    <Grid item sm={6} md={6}  >
                        <Controller
                            control={control}
                            name={"fecha_desde"}
                            render={({ field }) => <DateTimePickerInputWithLabel
                                keyValue={field.name}
                                errorMessage={errors[field.name]?.message}
                                label={"Fecha desde"}
                                minDate={dayjs()}
                                disabled={hassDisabledInputs || hasDisabledOptions}
                                {...field}
                                inputProps={{ size: "small" }}

                            />}
                        />
                    </Grid>
                    <Grid item sm={6} md={6}  >
                        <Controller
                            control={control}
                            name={"fecha_hasta"}
                            render={({ field }) => <DateTimePickerInputWithLabel
                                keyValue={field.name}
                                errorMessage={errors[field.name]?.message}
                                label={"Fecha hasta"}
                                minDate={fecha_desde_select}
                                {...field}
                                inputProps={{ size: "small" }}
                                disabled={hassDisabledInputs || hasDisabledOptions}

                            />}
                        />
                    </Grid>
                    <Grid item sm={6} md={6}  >
                        <Controller
                            control={control}
                            name={"fecha_disponibilidad"}
                            render={({ field }) => <DateTimePickerInputWithLabel
                                keyValue={field.name}
                                errorMessage={errors[field.name]?.message}
                                label={"Fecha de disponibilidad del producto"}
                                minDate={fecha_desde_select}
                                {...field}
                                inputProps={{ size: "small" }}
                                disabled={hassDisabledInputs || hasDisabledOptions}

                            />}
                        />
                    </Grid>
                    <Grid item sm={6} md={6}  >
                        <Controller
                            control={control}
                            name={"es_especial"}
                            render={({ field }) => <SelectInputWithLabel
                                keyValue={field.name}
                                errorMessage={errors[field.name]?.message}
                                label={"¿Es oferta especial?"}
                                inputProps={{ size: "small" }}
                                size='small'
                                disabled={hassDisabledInputs || hasDisabledOptions}
                                items={[
                                    {
                                        label:"SI",
                                        value:"SI"
                                    },
                                    {
                                        label:"NO",
                                        value:"NO"
                                    }
                                ]}
                                {...field}
                               

                            />}
                        />
                    </Grid>
                    <Grid fontSize={'14px'} item sm={12} md={12} >
                        <Typography variant="h6" >Configuracion especial de precios</Typography>
                        <Typography variant="p"  ><strong>Precio base de venta:</strong> Este precio esta compuesto por el precio de la compra + los sobrecostos</Typography><br/>
                        <Typography variant="p" ><strong>Margen objetivo:</strong>Es un margen que se puede asignar para que el precio quede igual para todos los tipos de clientes</Typography><br/>
                        <Typography variant="p" ><strong>Precio de venta:</strong>Esta compuesto por el precio base de venta y el margen objetivo + el valor del servicio</Typography>

                    </Grid>
                    <Grid item sm={12} md={12} alignItems={"end"} justifyContent={"end"} display={"flex"} >
                                <Button  disabled={hassDisabledInputs || hasDisabledOptions} onClick={onAddCobertura} variant="contained" size="small" color="primary" >Añadir Cobertura</Button>
                    </Grid>
                    <Grid item sm={12} md={12}  >
                    <Typography variant="p" color={'red'} >{errors["centros_operacion"]?.message}</Typography>
                    <Controller
                            control={control}
                            name={"centros_operacion"}
                            render={({ field }) =>{

                                

                                return field.value?.map( (configCP,index)=><Grid key={configCP.cod} item container sx={12} md={12} >
                                <Grid sx={12} md={12} >
                                
                                <SelectInputWithLabel
                                    keyValue={'centro_operacion_cod'}
                                    errorMessage={errors[field.name]?.[index]?.["centro_operacion_cod"]?.message}
                                    label={"Centro de operacion de origen"}
                                    {...field}
                                    size="small"
                                    items={initialData.centrosOP}
                                    value={configCP["centro_operacion_cod"]}
                                    onChange={(e)=>{
                                        onChangeChildValue("centros_operacion",index,"centro_operacion_cod",e.target.value);
                                      
                                    }}
                                    disabled={hassDisabledInputs || hasDisabledOptions}
                                    />


                                </Grid>
                                <Grid sx={4} md={4} >
                                    <InputWithLabel
                                    keyValue={"costo_promedio"}
                                    errorMessage={errors[field.name]?.[index]?.["costo_promedio"]?.message}
                                    label={"Costo Promedio"}
                                   value={configCP["costo_promedio"]}
                                   onChange={(e)=>{
                                    onChangeChildValue("centros_operacion",index,"costo_promedio",e.target.value);
                                    
                                }}
                                disabled={hassDisabledInputs || hasDisabledOptions}
                                    />
                                </Grid>
                              
                                <Grid sx={4} md={4} >
                                    <InputWithLabel
                                    keyValue={"margen_venta"}
                                    errorMessage={errors[field.name]?.[index]?.["margen_venta"]?.message}
                                    label={"Margen venta"}
                                    value={configCP["margen_venta"]}
                                    onChange={(e)=>{
                                        onChangeChildValue("centros_operacion",index,"margen_venta",e.target.value);
                                      
                                    }}
                                    disabled={hassDisabledInputs || hasDisabledOptions}
                                    />
                                </Grid>
                                <Grid sx={4} md={4} >
                                    <InputWithLabel
                                    keyValue={"cantidad_disponible"}
                                    errorMessage={errors[field.name]?.[index]?.["cantidad_disponible"]?.message}
                                    label={"Cant. Disponible"}
                                    value={configCP["cantidad_disponible"]}
                                    onChange={(e)=>{
                                        onChangeChildValue("centros_operacion",index,"cantidad_disponible",e.target.value);
                                      
                                    }}
                                    disabled={hassDisabledInputs || hasDisabledOptions}
                                    />
                                </Grid>
                                <Grid item sm={12} md={12} alignItems={"end"} justifyContent={"end"} display={"flex"} sx={{marginTop:'4px'}} >
                                    <Button  disabled={hassDisabledInputs || hasDisabledOptions} 
                                    onClick={e=>onRemoveItemFormParent("centros_operacion",field.value[index].cod)} 
                                    variant="contained" 
                                    size="small" 
                                    color="error" >Remover</Button>
                                </Grid>

                        </Grid> );
                            }} 
                        />

                    </Grid>
                   






                    <Grid item sm={12} md={12} >
                        <DialogActions>
                            {buttomsAction.map(buttom => <Button
                                {...buttom.buttomProps}
                                variant='contained'
                            >
                                {buttom.title}
                            </Button>)}
                        </DialogActions>
                    </Grid>
                </Grid>
            </form>
        </DialogContent>

    </Dialog>)

}




const schemaCompraCotizaciones = yup.object({
    fecha_compra:yup.string(),
    compras:yup.array(
        yup.object({
            municipio: yup.object({
                label:yup.string(),
                value:yup.string()
            }).required(),
            cantidad: yup.string().required(),
          
        }).required()
    )
});

export const ModalComprarCotizaciones = ({
    opened,
    onCloseModal,
    cotizacionInfo={}
})=>{

    const [fechaCompra,setFechaCompra] = useState(dayjs());
    const { control, set, register, watch, handleSubmit, setValue,getValues, formState: { errors }, setError } = useForm({
        resolver: yupResolver(schemaCompraCotizaciones),
        defaultValues: {
            compras:[],
            fecha_compra:dayjs()
        
        }
    });
   

    const [totals,setTotals] = useState({});
    console.log({totals});

    const fecha_compra_form = watch("fecha_compra");
   
    useEffect(()=>{
        obtenerCompras();
    },[fecha_compra_form]);

    const {dispatch,store} = useContext( AppContext );

    const obtenerCompras = async()=>{

        const  {data:{value}}= await AxiosInstance.post("maestros/obtener-compras-cotizacion",{
             prod_cod:cotizacionInfo.codigo_producto,
             cot_cod:cotizacionInfo.cotizacion_cod,
             fecha_entrega:fecha_compra_form.format(DateFormatString),
             un_medida:cotizacionInfo.cotizacion_un_md
         });
         setTotals(value.totals);
         const ArrayCompras = value.cesta.map( item=>({
            cod_cesta:item.cod,
            municipio:{label:item.nombre_municipio,value:item.codigo_mun},
            bodega: item.cod_bodega?{value:item.cod_bodega,label:item.nombre_bodega,cp_code:item.cod_centro_operacion}:null,
            cantidad:item.cantidad,
            cantidad_um:item.total_comprado_um,
            conversion_factor:item.prod_conversion_peso,
            estado:item.ind_estado,
            centro_operacion:item.cod_centro_operacion
         }));
         
         setValue("compras",ArrayCompras);

    }


    const onSubmit = async(values)=>{
        const TotalComprar = values.compras.reduce((counter,item)=>{
            return  counter + Number(item.cantidad);
        },0);
        const hasUnsavedChanges = values.compras.some( itemIn =>itemIn.cambio_sin_guardar );
        if ( hasUnsavedChanges ){
            dispatch({
                type:ActionTypes.setModalInfo,
                data:{
                    title:"Cambios sin guardar",
                    message:"Debe guardar sus cambios antes de confirmar",
                    type: DialogType.informativo,
                    isVisible: true
                }
            });
            
            return;
        }
       
        if (cotizacionInfo.total_disponible < TotalComprar){
            dispatch({
                type:ActionTypes.setModalInfo,
                data:{
                    title:"Disponible superado",
                    message:"Esta superando la cantidad disponible del producto",
                    type: DialogType.peligro,
                    isVisible: true
                }
            });
            
            return;
        }
       
        dispatch({
            type:ActionTypes.setLoadingPage,
            data:true
          });

        let result = await AxiosInstance.post("necesidades/confirmar-ordenes-cesta",{
            cod_producto:cotizacionInfo.codigo_producto,
            fecha_entrega:dayjs(values.fecha_compra).format(DateFormatString),
            cod_unidad_medida:cotizacionInfo.cotizacion_un_md
        });
        await obtenerCompras();
        dispatch({
            type:ActionTypes.setLoadingPage,
            data:false
        });
        if (result.data.status){
            
            dispatch({
              type: ActionTypes.setModalInfo,
              data: {
                title: "Ordenes Preconfirmadas",
                message: "Sus ordenes se han preconfirmado, Por favor confirmelas para poder generar los documentos ",
                type: DialogType.exitoso,
                isVisible: true
              }
            });

        }else{

            dispatch({
              type: ActionTypes.setModalInfo,
              data: {
                title: "Error al preconfirmar Ordenes",
                message: result.data.msg,
                type: DialogType.informativo,
                isVisible: true
              }
            });
        }

    }





    const addDestinoCompra = ()=>{
        let actualArray = getValues("compras");
        actualArray.push({
            municipio:null,
            cantidad:null,
            estado:"BORRADOR",
            cambio_sin_guardar:true,
            bodega:null
        });
        setValue("compras",actualArray);
    }
    console.log({errors});
    const CambiarFechaCompra = (date)=>{
        setValue("fecha_compra",date);
    }

    const opeWindowChatWap = ()=>{
        window.open(`https://wa.me/57${cotizacionInfo.celular}`,"_blank");
    }
    const userByConfirm = cotizacionInfo.estado_usuario === 'POR CONFIRMAR';
    const disabledCreation = !fechaCompra.isBetween(cotizacionInfo.cotizacion_fecha_desde,dayjs(cotizacionInfo.cotizacion_fecha_hasta).add(1,"days"),undefined,"[]") || fechaCompra.isBefore(dayjs().add(-1,"days")) || userByConfirm;
    return (
        <Dialog
        open={opened}
        >
            <DialogTitle>
                Comprar cotizacion
            </DialogTitle>
            <DialogContent>
                <form onSubmit={handleSubmit(onSubmit)} >
                <Grid container >
                    <Grid item sm={12} md={12} >
                        <Typography variant="h6" >Informacion de la cotizacion</Typography>
                    </Grid>
                    <Grid item sm={12} md={12} >
                       <strong> <Typography variant="p" >Producto: {cotizacionInfo.nombre_producto}</Typography></strong> <br/>
                        <Typography     variant="p" ><strong>Nombre proveedor: </strong> {cotizacionInfo.razon_social}</Typography> <br/>
                        <Typography variant="p" ><strong>Telefono proveedor: </strong> {cotizacionInfo.celular}</Typography> <IconButton onClick={opeWindowChatWap} ><WhatsApp /></IconButton>  <br/>
                        <Typography variant="p" ><strong>Punto de entrega:</strong> {cotizacionInfo.cotizacion_destino_name}</Typography><br/>
                        <Typography variant="p" ><strong>Cantidad ofertada:</strong> {FormatPrice(cotizacionInfo.cotizacion_cantidad)} X {cotizacionInfo.nombre_unidad_medida}</Typography><br/>
                        <Typography variant="p" ><strong>Vigencia:</strong> {cotizacionInfo.cotizacion_fecha_desde} - {cotizacionInfo.cotizacion_fecha_hasta}</Typography><br/>
                        <Typography variant="p" ><strong>Dias de entrega:</strong >{cotizacionInfo.cotizacion_n_dias_entrega}</Typography><br/>
                        <Typography variant="p" ><strong>Total kilos:</strong> {FormatPrice(cotizacionInfo.total_kg_ofertado) }</Typography><br/>
                        <Typography variant="p" ><strong>Precio X {cotizacionInfo.nombre_unidad_medida} :</strong >{FormatPrice(cotizacionInfo.cotizacion_precio_un)}</Typography><br/>
                        <Typography variant="p" ><strong>Precio X KG :</strong >{FormatPrice(cotizacionInfo.valor_kg)}</Typography><br/>
                        <Chip color="success" label={"Cantidad disponible: "+FormatPrice(cotizacionInfo.total_disponible)+" KG"} />
                        {
                            userByConfirm &&  <Alert severity="error">El proveedor no se encuentra habilitado para vender productos</Alert>
                        }
                       
                      
                    </Grid>
                   
                    <Grid item sm={12} md={12} >
                        <Typography variant="h6" >Datos de la compra</Typography>
                    </Grid>
                    <Grid item sm={5} md={5} >
                        <Chip color="primary" sx={{color:"white"}} label={"Total kilos comprados: "+FormatPrice( totals.total_kilos_comprados )} />
                    </Grid>
                    <Grid item sm={7} md={7} >
                    <Chip color="secondary" sx={{marginBottom:'2px'}} label={"Costo total base: $"+FormatPrice(totals.total_valor_base)} ></Chip>
                    <Chip color="secondary" label={"Costo total de la mercancia: $"+FormatPrice(totals.total_precio_mercancia)} ></Chip>
                    </Grid>
                    <Grid item sm={12} md={12} >
                        <div style={{
                            height:'10px'
                        }} >

                        </div>
                    </Grid>
                    
                    <Grid  item sm={8} md={8} >
                    <InputLabel>Fecha de entrega</InputLabel>
                    <Controller
                                    control={control}
                                    name={"fecha_compra"}
                                    render={({ field })=>{
                                       
                                       return <DatePicker   {...field} 
                                       onChange={CambiarFechaCompra}   
                                       slotProps={{ textField: { error: !!errors[field.name] } }} minDate={dayjs(cotizacionInfo.cotizacion_fecha_desde)}  />
                                    }}
                                    />
                    </Grid>
                    <Grid item sm={4} md={4} >
                        <Button disabled={disabledCreation} onClick={addDestinoCompra} variant="contained" color="primary" size="small" >Nuevo destino</Button>
                    </Grid>
                    
                    <Grid item sm={12} md={12} >
                        
                                <Controller
                                    control={control}
                                    name={"compras"}
                                    render={({ field }) =>field.value.map((item,index)=><CompraProductos 
                                    obtenerCompras={obtenerCompras}
                                    cotizacionInfo={cotizacionInfo}
                                    fecha_compra={dayjs(getValues("fecha_compra")).format(DateFormatString)}  
                                    errrors={errors[field.name]}
                                    disabledCreation={disabledCreation}
                                    setError={setError}
                                    key={index} 
                                    {...field} 
                                    index={index} />) }
                                />

                    </Grid>
                   
                    
                </Grid>
            <DialogActions>
                <Button type="button" onClick={onCloseModal} variant="contained" color="secondary"  >Cerrar</Button>
                <Button  disabled={disabledCreation}   type="submit" variant="contained" color="primary"  >Preconfirmar cotizacion</Button>
            </DialogActions>
                </form>
            </DialogContent>
           
        </Dialog>
    )
}


const  CompraProductos = ({
    index,
    value,onChange,
    onSaveItem,
    fecha_compra,
    cotizacionInfo,
    errrors = [],
    obtenerCompras,
    setError,
    disabledCreation
})=>{

    const [municipioList, setMunicipioList] = useState([]);
    const [bodegasFilter,setBodegasFilter] = useState([]);
    const [sobrecostos,setSobrecostos] = useState({});
    const {dispatch,store} = useContext( AppContext );

    useEffect(()=>{
        if ( value[index].municipio && value[index].bodega ){
            loadSobrecostoItem(value[index].municipio,value[index].bodega);
        }
      
    },[value[index].municipio,value[index].bodega]);

    useEffect(()=>{

         

    },[]);

  

    const onSearchMunicipio = async (value_search) => {

        if (value_search) {
          const { data: { value } } = await AxiosInstance.post("maestros/get-municipio-filter", {
            search_query: value_search
          })
          return value.map(mun => ({
            label: `${getLabelMunicipio(mun.desc_departamento,mun.descripcion)}`,
            value: mun.cod
          }))
    
        }
    
    
    
      }
    
      const searchMunicipiosOrigen = async (event, newInputValue) => {
        try {
          let res = await onSearchMunicipio(newInputValue);
          setMunicipioList(res);
        } catch (e) {
    
        }
      }

      const loadSobrecostoItem = async(municipioData,bodegaData)=>{
        if (municipioData && Object.keys(municipioData).length  > 0  ){
            let {data:{value}} = await AxiosInstance.post("maestros/maestros-calcular-sobrecostos-productos",{
                prod_cod:cotizacionInfo.codigo_producto,
                cotizacion_cod:cotizacionInfo.cotizacion_cod,
                mun_origen:cotizacionInfo.mun_origen_cal,
                mun_destino:municipioData.value,
                fecha_entrega:fecha_compra,
                cod_bodega:bodegaData.value
            });
           setSobrecostos(value);
        }
       
      }
      const onChangeItem = (name,valueIn)=>{
        let copyObject = [...value];
          
            if ( name === 'cantidad' ){
               
                    valueIn = Number(valueIn);
                    copyObject[index]["cantidad"] =  valueIn * cotizacionInfo.prod_conversion_peso;
                    copyObject[index]["cantidad_um"] = valueIn;
                    copyObject[index].cambio_sin_guardar = true;
               
            }else{
                if (name === 'municipio'){
                    loadSobrecostoItem(valueIn);
                }
            
                copyObject[index][name] = valueIn;
                copyObject[index].cambio_sin_guardar = true;
            }
                
                
                
                onChange(copyObject);
      }

      const onDeleteItem = ()=>{
            

          if ( value[index].cod_cesta ){
            dispatch({
                type:ActionTypes.setLoadingPage,
                data:true
              });
            AxiosInstance.post("necesidades/drop_carrito_compras",{
                cod_cesta:value[index].cod_cesta
            })
            .then(({data})=>{
                const res =  value.filter((item,indexF)=>indexF!== index );    
                onChange(res);      
            }).catch(err=>{
                alert("error");
            })
            .finally(()=>{
                dispatch({
                    type:ActionTypes.setLoadingPage,
                    data:false
                  });
            });
          }else{
            const res =  value.filter((item,indexF)=>indexF!== index );    
            onChange(res);       
          }

          
                                                                  
      }


     const sendToSaveItem = async()=>{

        let arrayErr = [];
        let errorInfo = {}
        console.log({value});
        if ( !value[index].bodega){
            errorInfo["bodega"] = {
                type:"campo requerido",
                message:"Campo no valido"
            };
            
           
        }
        if ( !value[index].municipio){

            errorInfo["municipio"] = {
                type:"campo requerido",
                message:"Campo no valido"
            };
        
        }
        if ( !value[index].cantidad ){
            errorInfo["cantidad"] = {
                type:"campo requerido",
                message:"Campo no valido"
            };
        }
        if (  (!value[index].cantidad || !value[index].municipio ) || ( errorInfo["bodega"] && Object.keys(errorInfo["bodega"] ).length > 0) ){
            arrayErr[index] = errorInfo;
            setError("compras",arrayErr);
            console.log("set errro");
            return;
        }
      
        dispatch({
            type:ActionTypes.setLoadingPage,
            data:true
          });
        await AxiosInstance.post("necesidades/actualizar-carrito-compras",{
            cod_producto:cotizacionInfo.codigo_producto,
            cod_cotizacion:cotizacionInfo.cotizacion_cod,
            fecha_entrega:fecha_compra,
            cod_unidad_medida:cotizacionInfo.cotizacion_un_md,
            cod_municipio:value[index].municipio.value,
            cantidad:value[index].cantidad,
            precio_unitario:precio_unitario,
            bodega:value[index].bodega?.value,
            centro_operacion:value[index].bodega?.cp_code || value[index].centro_operacion,
            tipo_origen_compra:"LIBRE"
        });
       await obtenerCompras();
       dispatch({
        type:ActionTypes.setLoadingPage,
        data:false
      });
     } 

    const loadBodegas = async(search)=>{
        console.log({value});
        if (value[index].municipio){

            const  {data:{value:result}} = await AxiosInstance.post("cotzaciones/obtener-bodegas-filter",{
                municipio_id:value[index].municipio.value,
                search
            });
            setBodegasFilter(result);
        }
    }
    const searchBodega = async (event, newInputValue) => {
        console.log({newInputValue});
        await loadBodegas(newInputValue.toLowerCase());
       
       
    } 

    const precio_unitario = Number(cotizacionInfo?.valor_kg || 0 ) +Number(sobrecostos?.total_sobrecosto || 0);

    return (
      <Card sx={{margin:'5px'}} >
        <CardContent>
        <Grid container >
            <Grid item sm={5} md={5}  >
                       
                       <Grid container >
                                <Grid item sm={12} md={12} > 
                                    <Autocomplete 
                                    {...{
                                            disabled: value[index].estado !== 'BORRADOR',    
                                            value:value[index].municipio,
                                            onChange:(e,val)=>onChangeItem("municipio",val),
                                            name: "municipio",
                                            fullWidth: true,
                                            isLoading: false,
                                            multiple: false,
                                            PopperComponent: (props) => <div hidden={!props.open} >
    
                                                {props.children}
                                            </div>,
                                            onInputChange: searchMunicipiosOrigen,
                                            options:  municipioList || [],
                                            noOptionsText: "Lista vacia",
                                            getOptionLabel: (option) => option.label,
                                            isOptionEqualToValue: (option, valueIn) => option.value === valueIn.value,
                                            filterOptions: (x) => x,
                                            size: "small",
                                            renderInput: (params) =>{
                                                return (
                                                   <>
                                                    <TextField error={errrors[index]?.municipio?.message} {...params} label="Municipio" />
                                                    {errrors[index]?.municipio?.message &&  <Typography variant="p" fontSize='12px' sx={{color:red[500]}}  >{errrors[index]?.municipio?.message}</Typography>}
                                                   </>
                                                )
                                            }
                                    }}
                                    
                                    />
                                   
                                   
                                </Grid>
                                <Grid item sm={12} md={12} > 
                                    <Autocomplete 
                                    {...{
                                        sx:{marginTop:'10px'},
                                            disabled: value[index].estado !== 'BORRADOR',    
                                            value:value[index].bodega,
                                            onChange:(e,val)=>onChangeItem("bodega",val),
                                            name: "bodega",
                                            fullWidth: true,
                                            isLoading: false,
                                            multiple: false,
                                            PopperComponent: (props) => <div hidden={!props.open} >
    
                                                {props.children}
                                            </div>,
                                            onInputChange: searchBodega,
                                            options:  bodegasFilter || [],
                                            noOptionsText: "Lista vacia",
                                            getOptionLabel: (option) => option.label,
                                            isOptionEqualToValue: (option, valueIn) => option.value === valueIn.value,
                                            filterOptions: (x) => x,
                                            size: "small",
                                            renderInput: (params) =>{
                                                return (
                                                   <>
                                                    <TextField error={errrors[index]?.bodega?.message} {...params} label="Bodega" />
                                                    {errrors[index]?.bodega?.message &&  <Typography variant="p" fontSize='12px' sx={{color:red[500]}}  >{errrors[index]?.bodega?.message}</Typography>}
                                                   </>
                                                )
                                            }
                                    }}
                                    
                                    />
                                   
                                   
                                </Grid>
                            <Grid item sm={12} md={12} >
                                <InputLabel>Cantidad a comprar</InputLabel>
                                    <Input
                                        disabled={ value[index].estado !== 'BORRADOR' }
                                        error={ errrors[index]?.cantidad?.message }
                                        value={value[index].cantidad_um}
                                        endAdornment={<InputAdornment position="end" >{cotizacionInfo?.nombre_corto_unidad_medida}</InputAdornment>}
                                        type="number"
                                        size="small"
                                        onChange={e=>onChangeItem("cantidad",e.target.value)}
                                    /><br/>
                                     {errrors[index]?.cantidad?.message &&  <Typography variant="p" fontSize='12px' sx={{color:red[500]}}  >{errrors[index]?.cantidad?.message}</Typography>}

                            </Grid>
                        </Grid>
                          
                    

                </Grid>
                <Grid item sm={1} md={1}  ></Grid>
                <Grid item sm={5} md={5}  >
                    <Typography sx={{fontSize:'1rem'}} variant="h6" >Sobrecostos</Typography>   
                   {
                    sobrecostos.listSobrecosto?.map(sobrecosto=>
                        <Typography key={sobrecosto.cod_sobrecosto} sx={{fontSize:'0.8rem'}}  >{sobrecosto.nombre_sobrecosto}: {FormatPrice(sobrecosto.valor_sobrecosto)}</Typography>   
                        )
                    
                   }
                   {
                    sobrecostos.total_sobrecosto && <Chip variant="filled" sx={{color:"white"}} label={"Precio total: "+FormatPrice( precio_unitario )} color="primary" />  
                   }
                    
                </Grid>
                <Grid item sm={1} md={1}  >
                <IconButton  disabled={!value[index].cambio_sin_guardar || disabledCreation}  onClick={sendToSaveItem} sx={{bgcolor:'success.main',color:'success.contrastText',marginBottom:'10px'}} aria-label="Guardar ítem" ><Save /></IconButton>
                    <IconButton disabled={value[index].estado !== 'BORRADOR' || disabledCreation} onClick={onDeleteItem} sx={{background:red[500],color:"white"}} ><Delete /></IconButton>
                    
                </Grid>
        </Grid>
        </CardContent>
      </Card>
    )

}



const  PuntosEntrega = ({
    disabled,
    index,
    value,
    onChange,
    centrosOperaciones,
    errrors = [],
})=>{


      const onChangeItem = (name,valueIn)=>{
        let copyObject = [...value];
        copyObject[index][name] = valueIn;
        onChange(copyObject);
      }

        const onDeleteItem = ()=>{
            const res =  value.filter((item,indexF)=>item.cod!== value[index].cod );    
            onChange(res);     
        }

    return (
      <Card sx={{margin:'5px'}} >
        <CardContent>
        <Grid container spacing={1} >
                                <Grid item sm={12} md={6} > 
                                     <InputLabel>Centro de operacion</InputLabel>
                                    <Autocomplete 
                                    {...{
                                            value:value[index].centro_operacion,
                                            onChange:(e,val)=>onChangeItem("centro_operacion",val),
                                            name: "centro_operacion",
                                            fullWidth: true,
                                            isLoading: false,
                                            multiple: false,
                                            disabled:disabled,
                                            PopperComponent: (props) => <div hidden={!props.open} >
    
                                                {props.children}
                                            </div>,
                                            options:  centrosOperaciones || [],
                                            noOptionsText: "Lista vacia",
                                            getOptionLabel: (option) => option.label,
                                            isOptionEqualToValue: (option, valueIn) => option.value === valueIn.value,
                                            filterOptions: (x) => x,
                                            size: "small",
                                            renderInput: (params) =>{
                                                return (
                                                   <>
                                                    <TextField error={errrors[index]?.centro_operacion?.message} {...params} label="Centro de operacion" />
                                                    {errrors[index]?.centro_operacion?.message &&  <Typography variant="p" fontSize='12px' sx={{color:red[500]}}  >{errrors[index]?.centro_operacion?.message}</Typography>}
                                                   </>
                                                )
                                            }
                                    }}
                                    
                                    />
                                   
                                   
                                </Grid>
                
                            <Grid item sm={4} md={4} >
                                <InputLabel>Cantidad a entregar</InputLabel>
                                    <Input
                                        disabled={disabled}
                                        error={ errrors[index]?.cantidad?.message }
                                        value={value[index].cantidad}
                                        //endAdornment={<InputAdornment position="end" >{cotizacionInfo?.nombre_corto_unidad_medida}</InputAdornment>}
                                        type="number"
                                        size="small"
                                        onChange={e=>onChangeItem("cantidad",e.target.value)}
                                    /><br/>
                                     {errrors[index]?.cantidad?.message &&  <Typography variant="p" fontSize='12px' sx={{color:red[500]}}  >{errrors[index]?.cantidad?.message}</Typography>}

                            </Grid>
                            <Grid item sm={1} md={1}  >
                    <IconButton 
                        disabled={disabled}
                        onClick={onDeleteItem} 
                        sx={{background:red[500],color:"white"}} 
                    ><Delete /></IconButton>
                </Grid>
                        </Grid>
        </CardContent>
      </Card>
    )

}

const schemaSubastas = yup.object({
  fecha_inicio: yup.mixed().required(),
  fecha_fin: yup.mixed().required(),
  //tyc: yup.string().required(),
  cantidad_requerida: yup.number().optional(),
  producto:yup.mixed().required(),
  valor_apertura:yup.number().min(1).required(),
  puntos_entrega: yup.array().of(
    yup.object({
        centro_operacion:yup.mixed().required(),
        cantidad:yup.number().optional().notRequired()
    })
  ).min(1).required(),

});

export const ModalSubastas = ({
    opened,
    onCloseModal,
    subasta_info={},
    tipoAction,
    onLoadData = ()=>{},
    
})=>{

    const { control,handleSubmit, setValue,getValues, formState: { errors } } = useForm({
        resolver: yupResolver(schemaSubastas),
        defaultValues: {...subasta_info}
    });
   
    const {dispatch,store} = useContext( AppContext );
    const [centrosOperaciones,setCentrosOperaciones] = useState([]);
    const [productos,setProductos] = useState([]);

    const onSubmit = async(values)=>{
        const TotalValorDistribuido = values.puntos_entrega.reduce((counter,item)=>{
            return  counter + Number(item.cantidad);
        },0);
        console.log({
            TotalValorDistribuido,
            req:values.cantidad_requerida
        });
        if ( TotalValorDistribuido !== values.cantidad_requerida ){
            dispatch({
                type:ActionTypes.setModalInfo,
                data:{
                    title:"Valores incorrectos",
                    message:"El total a distribuir no concuerda con el valor de la necesidad",
                    type: DialogType.peligro,
                    isVisible: true
                }
            });
            
            return;
        }
       
        dispatch({
            type:ActionTypes.setLoadingPage,
            data:true
          });

        const payload = {
            ...values,
            fecha_inicio:dayjs(values.fecha_inicio).format(DateTimeFormatString),
            fecha_fin:dayjs(values.fecha_fin).format(DateTimeFormatString),

        }

         AxiosInstance.post("subastas/registrar-subasta",payload).then( ({data})=>{
            onLoadData();
            onCloseModal();
            dispatch({
              type: ActionTypes.setModalInfo,
              data: {
                    title: "Subasta publicada",
                    message: "La subasta ha sido publicada con exito",
                    type: DialogType.exitoso,
                    isVisible: true
              }
            });
         }).catch(error=>{
            console.log(error.message);
            dispatch({
              type: ActionTypes.setModalInfo,
              data: {
                title: "Error de guardado",
                message:error.msg,
                type: DialogType.peligro,
                isVisible: true
              }
            });
         }).finally( ()=>{
            dispatch({
                type:ActionTypes.setLoadingPage,
                data:false
            });
         } );


    }





    const addDestinoCompra = ()=>{
        let actualArray = getValues("puntos_entrega");
        actualArray.push({
            cod:new Date().getTime(),
            centro_operacion:null,
            cantidad:0
        });
        setValue("puntos_entrega",actualArray);
    }

    const onChangeInput = (key,vale)=>{
       setValue(key,vale);
    }
    console.log({errors});

    useEffect(()=>{
            loadCentroOperacion();
    },[]);

        const loadCentroOperacion = async (value_search) => {
          const { data: { value } } = await AxiosInstance.get("Sucursales/obtener-centros-operacion-destino", {
            search_query: value_search
          })
          setCentrosOperaciones(value);    
      }


          const onSearchProducto = async (value_search) => {

        if (value_search) {
            try {

                const { data: { value } } = await AxiosInstance.post(`cotzaciones/buscar-productos-nombre`, {
                    nombre_prod: value_search
                });
                return value.map( item=>({
                    label:`${item.cod_erp}-${item.descripcion}`,
                    value:item.cod
                }) );
            } catch (e) {
                return [];
            }

        }



    }
    const searcProductoAsociado = async (event, newInputValue) => {

        try {
            let res = await onSearchProducto(newInputValue);
            setProductos(res);
           
        } catch (e) {
            console.log(e.message);
        } 
    }

    return (
        <Dialog
        open={opened}
        >
            <DialogTitle>
                {tipoAction === FormActions.AGREGAR? 'Crear Subasta':"Editar Subasta"}
            </DialogTitle>
            <DialogContent>
                <form onSubmit={handleSubmit(onSubmit)} >
                <Grid container >
                
                    
                    <Grid item sm={12} md={12} >
                        <Typography variant="h6" >Datos de la subasta</Typography>
                    </Grid>
                    
                    <Grid  item sm={6} md={6} >
                        <InputLabel>Fecha de apertura</InputLabel>
                        <Controller
                            size="small"
                            control={control}
                            name={"fecha_inicio"}
                            
                            render={({ field })=>{
                                
                                return <DateTimePicker   {...field} 
                                format="YYYY-MM-DD HH:mm:ss"
                                size="small"
                                disabled={tipoAction === FormActions.MODIFICAR}  
                                onChange={date=>onChangeInput("fecha_inicio",date)}   
                                slotProps={{ textField: { size: "small", error: !!errors[field.name] } }} minDate={dayjs()}  />
                            }}
                            />
                    </Grid>
                    <Grid  item sm={6} md={6} >
                        <InputLabel>Fecha de cierre</InputLabel>
                        <Controller
                            size="small"
                            control={control}
                            name={"fecha_fin"}
                            
                            render={({ field })=>{
                                
                                return <DateTimePicker   {...field} 
                                format="YYYY-MM-DD HH:mm:ss"
                                size="small"
                                disabled={tipoAction === FormActions.MODIFICAR} 
                                onChange={date=>onChangeInput("fecha_fin",date)}   
                                slotProps={{ textField: { disabled: tipoAction === FormActions.EDITAR, size: "small", error: !!errors[field.name] } }} minDate={dayjs()}  />
                            }}
                            />
                        </Grid>
                        <Grid item sm={12} md={12} >
                            <InputLabel>Producto</InputLabel>
                            <Controller
                            
                            size="small"
                            control={control}
                            name={"producto"}
                            
                            render={({ field })=><Autocomplete
                                {...{
                                    value: field.value,
                                    onChange: (e, val) => onChangeInput("producto", val),
                                    name: "producto",
                                    fullWidth: true,
                                    disabled:tipoAction === FormActions.MODIFICAR, 
                                    options: productos || [],
                                    noOptionsText: "Lista vacia",
                                    filterOptions: (x) => x,
                                    size: "small",
                                    onInputChange: searcProductoAsociado,
                                    renderInput: (params) => {
                                        return (
                                            <>
                                                <TextField error={errors[field.name]?.message} {...params} />
                                                {errors[field.name]?.message && <Typography variant="p" fontSize='12px' sx={{ color: red[500] }}  >{errors[field.name]?.message}</Typography>}
                                            </>
                                        )
                                    }
                                }}

                            />}
                            />


                        </Grid>
{/*                     <Grid  item sm={12} md={12} >
                        <InputLabel>Descripcion Basica</InputLabel>
                        <Controller
                            size="small"
                            control={control}
                            name={"tyc"}
                            
                            render={({ field })=><Input error={errors[field.name]?.message} rows={2} fullWidth type="text"  {...field} />}
                            />
                    </Grid> */}
                    <Grid  item sm={6} md={6} >
                        <InputLabel>Precio de apertura (Opcional)</InputLabel>
                        <Controller
                            size="small"
                            control={control}
                            name={"valor_apertura"}
                            
                            render={({ field })=><Input  
                            disabled={tipoAction === FormActions.MODIFICAR}
                            error={errors[field.name]?.message} type="number"  {...field} />}
                            />
                             <FormHelperText error={errors["valor_apertura"]?.message} >{errors["valor_apertura"]?.message}</FormHelperText>
                    </Grid>
                    <Grid  item sm={6} md={6} >
                        <InputLabel>Cantidad requerida (Opcional)</InputLabel>
                        <Controller
                            size="small"
                            control={control}
                            name={"cantidad_requerida"}
                            
                            render={({ field })=><Input 
                            disabled={tipoAction === FormActions.MODIFICAR}
                            error={errors[field.name]?.message} type="number"  {...field} />}
                            />
                    </Grid>
                     <Grid item sm={12} md={12} >
                        <Typography variant="h6" >Puntos de entrega</Typography>
                    </Grid>
                    <Grid item sm={4} md={4} >
                        <Button 
                        disabled={tipoAction === FormActions.MODIFICAR}
                        onClick={addDestinoCompra} variant="contained" color="primary" size="small" >Agregar</Button>
                    </Grid>
                    
                    <Grid item sm={12} md={12} >
                        
                        <Controller
                            control={control}
                            name={"puntos_entrega"}
                            render={({ field }) =>field.value?.map((item,index)=><PuntosEntrega 
                            disabled={tipoAction === FormActions.MODIFICAR}
                            value={field.value}
                            centrosOperaciones={centrosOperaciones}
                            errrors={errors[field.name]}
                            key={item.cod} 
                            onChange={value=>onChangeInput("puntos_entrega",value)}
                            index={index} />) }
                        />
                        <FormHelperText error={errors["puntos_entrega"]?.message} >{errors["puntos_entrega"]?.message}</FormHelperText>

                    </Grid>
                   
                    
                </Grid>
            <DialogActions>
                <Button type="button" onClick={onCloseModal} variant="contained" color="secondary"  >Cerrar</Button>
                <Button disabled={tipoAction === FormActions.MODIFICAR} type="submit" variant="contained" color="primary"  >Publicar subasta</Button>
            </DialogActions>
                </form>
            </DialogContent>
           
        </Dialog>
    )
}